import { FC, Fragment } from "react";
import { Close } from "@mui/icons-material";
import { Divider, IconButton, Stack, Typography } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureSelectedRegionSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureSelectedRegionSelector";

interface InfrastructureArchitectureRecommendationDrawerDocDrawerHeaderProps {
  closeDialog(): void;
}

export const InfrastructureArchitectureRecommendationDrawerDocDrawerHeader: FC<
  InfrastructureArchitectureRecommendationDrawerDocDrawerHeaderProps
> = ({ closeDialog }) => {
  const selectedRegion = useAppSelector(
    infrastructureArchitectureSelectedRegionSelector,
  );

  return (
    <Fragment>
      <Stack
        direction="row"
        px={2}
        py={1.5}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="subtitle1" fontWeight="medium">
          Architecture Documentation:
          <Typography
            px={1}
            ml={0.5}
            py={0.25}
            borderRadius={1}
            variant="body2"
            component="span"
            bgcolor="grey.200"
            color="text.secondary"
          >
            {selectedRegion}
          </Typography>
        </Typography>

        <IconButton onClick={closeDialog} size="small">
          <Close fontSize="inherit" />
        </IconButton>
      </Stack>
      <Divider />
    </Fragment>
  );
};
